export default {
  getPurchaseLimit: (state) => state.purchaseLimit,
};
